// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subsidiaryInformation-form.section[data-v-0df71260] {\n  padding: 10px 20px 20px 20px;\n}\n.subsidiaryInformation-form .el-select[data-v-0df71260] {\n  width: 100%;\n}\n.subsidiaryInformation-form .no-pointer[data-v-0df71260]  .el-checkbox__input {\n  cursor: default;\n}\n", ""]);
// Exports
module.exports = exports;
